import orderBy from 'lodash/orderBy';
import { hideWhenReadOnlyRule } from './commonRules';
const CUSTOMBUTTONCLASS_MAP = {
    'inca-btn-primary': 'primary',
    'inca-btn-success': 'success',
    'inca-btn-info': 'info',
    'inca-btn-warning': 'warning',
    'inca-btn-danger': 'danger',
    'inca-btn-default1': 'default-1',
    'inca-btn-default2': 'default-2'
};
const normalizeCustomButtonClass = (buttonClass)=>{
    for(const incaButtonClass in Object.keys(CUSTOMBUTTONCLASS_MAP)){
        if (buttonClass.includes(incaButtonClass)) {
            return CUSTOMBUTTONCLASS_MAP[incaButtonClass];
        }
    }
    return 'default-1';
};
const normalizeCustomButtonIconClass = (icon)=>{
    return icon.replace('fa-', '').split(' ');
};
export const getCustomButtons = (inca)=>{
    const customButtonDefinitions = orderBy(inca.form.designedForm.customButtons.filter((x)=>x.isActive), (x)=>x.prio);
    return customButtonDefinitions.map((btn)=>{
        const res = {
            buttonStyle: normalizeCustomButtonClass(btn.buttonClass),
            defaultRules: [
                hideWhenReadOnlyRule
            ],
            icon: normalizeCustomButtonIconClass(btn.icon),
            async onClick (r, i) {
                return i.errand.customButton(btn.id);
            },
            prio: btn.prio,
            section: 'middle',
            text: btn.displayText,
            key: btn.shortName
        };
        return res;
    });
};
